/** TODO: Delete when migrating apply */
import React from 'react';
import { NumericFormat } from 'react-number-format';

const BankAccountNumberInput = (props, ref) => {
  const { onChange, ...other } = props;

  return (
    <NumericFormat
      {...other} // eslint-disable-line react/jsx-props-no-spreading
      getInputRef={ref}
      allowLeadingZeros
      allowNegative={false}
      valueIsNumericString
      onValueChange={(values) => onChange(values.formattedValue)}
    />
  );
};

export default React.forwardRef(BankAccountNumberInput);
